import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

const getAllUnaccountedHoursTickets = gql`
  query GetAllUnaccountedHoursTicketsQuery($startDate: String!, $endDate: String!) {
    all_unaccounted_hours_tickets(start_date: $startDate, end_date: $endDate) {
      edges {
        node {
          date {
            display
            iso8601
          }
          id    
          workedHoursEqualsBilling: worked_hours_equals_billing
          ticketNumber: ticket_number {
            number
            ticket {
              id
            }
          }
          job {
            id
            jobNumber: job_number
          }
          district {
            name
          }
          department {
            name
          }
          date {
            display
          }
          well {
            name
            lease {
              name
              operator {
                name
              }
            }
          }
          avgWorkedHours: avg_worked_time {
            toString: to_string
            totalSeconds: total_seconds
          }
          billingTime: billing_time {
            totalSeconds: total_seconds
            toString: to_string
          }
          deltaBilledAndWorkedTime: delta_billed_and_worked_time {
            toString: to_string
            totalSeconds: total_seconds
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allUnaccountedHoursTickets = querySelector(data, '$.all_unaccounted_hours_tickets.edges[*].node', []);

  return {
    ...ownProps,
    data,
    allUnaccountedHoursTickets,
  };
};

const queryGetAllUnaccountedHoursTicketsData = graphql(getAllUnaccountedHoursTickets, {
  props: marshallData,
});

export const queryGetAllUnaccountedHoursTicketsDataGQL = compose(
  queryGetAllUnaccountedHoursTicketsData,
  queryMetaHandler,
  omitProps(['data']),
);
